import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { FieldHookConfig, useField } from 'formik';
import { setFieldOnSessionStorage } from '../../helpers/helpers';
import IntlTelField from '../IntlTelField';

type PhoneNumberProps = FieldHookConfig<string> & {
  label: string;
  id: string;
  helperText?: string;
  formName?: string;
  objectId?: string;
  required?: boolean;
  type?: string;
  valid?: boolean;
  setValid?: Dispatch<SetStateAction<boolean>>;
  error?: string;
  clearError?: (errorKey?: string) => void;
  setError?: () => void;
  autoComplete?: string;
  defaultCountry?: string;
  countries?: string[];
};

const FormikPhoneNumber = (props: PhoneNumberProps) => {
  const [field, meta, helpers] = useField(props);
  const {
    label,
    id,
    formName,
    objectId = '',
    autoComplete = 'on',
    required = false,
    type = 'text',
    valid = true,
    setValid = () => {
      /* void */
    },
    error,
    setError = () => {
      /* void */
    },
    clearError,
    helperText = '',
    defaultCountry = 'gb',
    countries,
  } = props;
  const { t } = useTranslation();
  const { setValue } = helpers;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [changedPhoneNumber, setChangedPhoneNumber] = useState(false);
  const [first, setFirst] = useState(true);

  useEffect(() => {
    if (phoneNumber === '') {
      setPhoneNumber(field.value);
    }
    if (changedPhoneNumber) {
      setChangedPhoneNumber(false);
    } else setPhoneNumber(field.value);
  }, [field.value]);

  const handleChangeNumber = (
    _isValid: any,
    inputPhoneNumber: any,
    _country: any,
    countryNumber: any
  ) => {
    clearError?.(id);
    const formattedPhoneNumber = inputPhoneNumber.trim().replace(/[^0-9+\-()]/g, '');

    setPhoneNumber(formattedPhoneNumber);

    if (first) setFirst(false);
    else setChangedPhoneNumber(true);
    const formattedCountryNumber = countryNumber.trim().replace(/[^0-9+\-()]/g, '');

    if (formName) {
      setFieldOnSessionStorage(formName, objectId, field.name, formattedCountryNumber);
    }
    setValue(formattedCountryNumber);

    if (setValid) {
      setValid(isValidPhoneNumber(formattedCountryNumber));
    }
  };

  const handleChangeFlag = (
    _inputPhoneNumber: any,
    _country: any,
    countryNumber: any,
    _isValid: any
  ) => {
    clearError?.(id);

    const formattedCountryNumber = countryNumber.replace(/\s/g, '');
    setChangedPhoneNumber(true);
    if (formName) {
      setFieldOnSessionStorage(formName, objectId, field.name, formattedCountryNumber);
    }
    setValue(formattedCountryNumber);

    if (setValid) {
      setValid(isValidPhoneNumber(formattedCountryNumber));
    }
  };

  const handlePhoneNumberBlur = () => {
    helpers.setTouched(true);
    if (!valid && phoneNumber !== '' && setError) setError();
  };

  return (
    <IntlTelField
      value={phoneNumber}
      onSelectFlag={handleChangeFlag}
      defaultCountry={defaultCountry}
      onPhoneNumberChange={handleChangeNumber}
      onPhoneNumberBlur={handlePhoneNumberBlur}
      required={required}
      autoComplete={autoComplete}
      fieldId="PhoneNumber"
      fieldName="PhoneNumber"
      label={label}
      preferredCountries={[]}
      onlyCountries={countries}
      autoPlaceholder={false}
      size="small"
      variant="outlined"
      error={Boolean(error) || (meta.touched && Boolean(meta.error))}
      helperText={
        (Boolean(error) && error) ||
        (meta.touched && meta.error && t(meta.error, { field: label })) ||
        helperText
      }
    />
  );
};

export default FormikPhoneNumber;
